<template>
  <PopUpModalStrip ref="popup">
    <!-- ------------ -->
    <!--  container   -->
    <!-- ------------ -->
    <div class="container-fluid">
      <div class="col p-3">
        <!-- -------------- -->
        <!--  main column   -->
        <!-- -------------- -->
        <div
          class="row bb-sub-hdg mt-1 mb-3 justify-content-center text-center"
        >
          {{ title }} [{{ row.name }}]
        </div>
        <!-- ------- -->
        <!--  row 1  -->
        <!-- ------- -->
        <div class="row">
          <div class="bb-slot-listing">
            <!-- ----------- -->
            <!--   options   -->
            <!-- ----------- -->
            <div
              v-for="(opt, index) in available_options"
              :key="index"
            >
              <div class="col-lg px-1">
                <img
                  :id="'img_' + index"
                  :src="opt.image"
                  class="img-fluid rounded bb-img-norm-border bb-hover"
                  @click="optionClick"
                  alt="current option image"
                />
                <div
                  class="row bb-sub-sub-sub-hdg mt-3 mb-2 justify-content-center text-center"
                  :id="'lbl_' + index"
                >
                  {{ opt.label }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- ------- -->
        <!--  row 3  -->
        <!-- ------- -->
        <div class="row mt-2 mb-3">
          <!-- ------------ -->
          <!--    buttons   -->
          <!-- ------------ -->
          <div
            class="btn-group special"
            role="group"
          >
            <!-- ------------ -->
            <!--    cancel    -->
            <!-- ------------ -->
            <button
              type="submit"
              @click="_cancel"
              class="btn btn-lg btn-warning"
            >
              Cancel
            </button>
            <!-- ------------ -->
            <!--      OK      -->
            <!-- ------------ -->
            <button
              type="submit"
              @click="_confirm"
              :disabled="!isChanged"
              class="btn btn-lg btn-primary"
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
  </PopUpModalStrip>
</template>
<script>
//=====================================================================
// imports
//---------
import PopUpModalStrip from './PopUpModalStrip.vue'
import applyCombatOptionToggleState from '../helpers/applyCombatOptionToggleState'
// import getMarker from "../helpers/getMarker";
import sleep from '../helpers/sleep'

export default {
  name: 'OptionsDialog',
  components: {
    PopUpModalStrip,
  },
  //=====================================================================
  // data
  //------
  data: () => ({
    available_options: undefined,
    cur_options: undefined,
    original_options: undefined,
    title: undefined,
    row: undefined,
    okButton: 'OK',
    cancelButton: 'Cancel',
    resolvePromise: undefined,
    rejectPromise: undefined,
  }),
  computed: {
    isChanged() {
      return (
        JSON.stringify(this.cur_options ?? {}) !==
        JSON.stringify(this.original_options ?? {})
      )
    },
  },
  //=====================================================================
  // methods
  //---------
  methods: {
    //=====================================================================
    // show
    //------
    async show(opts = {}) {
      this.available_options = opts.available_options
      this.cur_options = opts.cur_options
      this.original_options = JSON.parse(JSON.stringify(opts.cur_options ?? {}))
      this.title = opts.title
      this.row = opts.row
      // this.okButton = opts.okButton;
      if (opts.cancelButton) {
        this.cancelButton = opts.cancelButton
      }
      //
      let call = this.$refs.popup.open()
      await call.then(() => {
        this.changeOptions()
      })
      //
      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve
        this.rejectPromise = reject
      })
    },
    //=====================================================================
    // confirm
    //---------
    _confirm() {
      if (!this.isChanged) {
        return
      }

      sleep(100).then(() => {
        this.$refs.popup.close()
        this.resolvePromise(this.cur_options)
      })
    },
    //=====================================================================
    // cancel
    //--------
    _cancel() {
      this.$refs.popup.close()
      this.resolvePromise()
    },
    //================================================
    // option click
    //--------------
    optionClick(e) {
      let img_id = e.target.id
      //--------------------------
      // get last char of id (idx)
      //---------------------------
      let idx = img_id.slice(-1)
      //--------------------------------------------
      // get option name from clicked avail options
      //--------------------------------------------
      let avail_opt_name = this.available_options[idx].name
      //---------
      // set ids
      //---------
      let lbl_id = 'lbl_' + idx
      //----------------------
      // get cur option value
      //----------------------
      let option = this.cur_options[avail_opt_name]
      //-------------------------
      // toggle cur option value
      //-------------------------
      option = !option
      //-------------------------------------------
      // apply shield/second-weapon exclusivity so
      // the dialog highlight matches saved state.
      //-------------------------------------------
      this.cur_options = applyCombatOptionToggleState({
        combatant: {
          ...this.row,
          shield: this.cur_options.shield,
          second_weapon: this.cur_options.second_weapon,
          cr: this.cur_options.cr ?? this.row.cr,
        },
        options: {
          ...this.cur_options,
          [avail_opt_name]: option,
        },
      })

      this.changeOptions()
    },
    //================================================
    // change options
    //----------------
    changeOptions() {
      console.log('-------------------')
      console.log('changeOptions')
      //--------------------------
      // loop thru available opts
      //--------------------------
      for (let i = 0; i < this.available_options.length; i++) {
        //---------
        // set ids
        //---------
        let img_id = 'img_' + i
        let lbl_id = 'lbl_' + i
        //-------------------
        // check cur options
        //-------------------
        let option = this.cur_options[this.available_options[i].name]
        //------------------
        // if true - enable
        //------------------
        if (option) {
          this.enableImage(img_id)
          this.enableText(lbl_id)
          //--------------------
          // if false - disable
          //--------------------
        } else {
          this.disableImage(img_id)
          this.disableText(lbl_id)
        }
      }
    },
    //================================================
    // enable image
    //--------------
    enableImage(id) {
      var el = document.getElementById(id)
      el.style.opacity = '1.0'
      el.style.pointerEvents = 'auto'
    },
    //================================================
    // enable text
    //-------------
    enableText(id) {
      var el = document.getElementById(id)
      el.style.color = '#25bfda'
    },
    //================================================
    // disable image
    //---------------
    disableImage(id) {
      var el = document.getElementById(id)
      el.style.opacity = '0.2'
      // el.style.pointerEvents = "none";
    },
    //================================================
    // disable text
    //--------------
    disableText(id) {
      var el = document.getElementById(id)
      el.style.color = '#737373'
    },
  },
}
</script>
